export default "__VITE_ASSET__DeBpqh7V__"